import { render, staticRenderFns } from "./step_5.vue?vue&type=template&id=671780df&scoped=true&"
import script from "./step_5.vue?vue&type=script&lang=js&"
export * from "./step_5.vue?vue&type=script&lang=js&"
import style0 from "./step_5.vue?vue&type=style&index=0&id=671780df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671780df",
  null
  
)

export default component.exports